'use client';

import { useState } from 'react';

// Wir nehmen die URL jetzt als Prop von der Kontakt-Seite entgegen
export default function TwoClickMap({ googleMapsUrl }) {
  const [isLoaded, setIsLoaded] = useState(false);

  // Fallback, falls kein Link übergeben wurde
  if (!googleMapsUrl) return null;

  if (isLoaded) {
    // Wenn aktiviert, laden wir das echte iFrame mit dem Link aus Strapi
    return (
      <div className="map-container active">
        <iframe
          src={googleMapsUrl}
          width="100%"
          height="100%"
          style={{ border: 0, filter: 'grayscale(0.3) sepia(0.1)' }} /* Dein Styling für die Karte übernommen */
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Maps Standort"
        ></iframe>
      </div>
    );
  }

  // Wenn nicht aktiviert, zeigen wir den DSGVO-Platzhalter
  return (
    <div className="map-container placeholder">
      <div className="map-privacy-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '15px' }}>
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
        
        <p>
          Um Ihre Privatsphäre zu schützen, haben wir die automatische Verbindung zu Google Maps deaktiviert. 
          Mit einem Klick auf die Karte wird eine Verbindung zu den Servern von Google hergestellt.
        </p>
        
        <button className="cta-button" onClick={() => setIsLoaded(true)} style={{ marginTop: '20px' }}>
          Karte aktivieren
        </button>
      </div>
    </div>
  );
}